import {
  GET_USERS_LIST,
  GET_USERS_LIST_FAILURE,
  GET_USERS_LIST_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getUsersListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS_LIST:
      return { ...state, loading: true };
    case GET_USERS_LIST_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_USERS_LIST_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getUsersListReducer;
